import { IGame } from './constants/games.constants';

export const gameHasPoolId = (game: IGame | undefined) => typeof game?.poolId !== 'undefined';
